import { InventoryCount } from 'types/inventory';

export type InventoryCountProps = {};

export type InventoryCountViewProps = {
  endDate?: Date;
  startDate?: Date;
  site?: string[];
  status?: string;
  defaultIndex: number;
  accountManagers?: string[];
  setDefaultIndex: (arg: number) => void;
  onSearchClear: () => void;
  onSearchPress: (startDate: Date | null, endDate: Date | null) => void;
  onStatusClick: (_status?: string) => void;
  onClearFilters: () => void;
  onApplyFilters: (data: string[], type: string) => void;
};
export type InventoryCountTabProps = {
  startDate?: Date;
  endDate?: Date;
  site?: string[];
  accountManagers?: string[];
  itemCount: (count: InventoryCount) => number;
  caseCount: (count: InventoryCount) => number;
  status?: number;
  isArchived?: boolean;
};

export enum Tabs {
  ALL = 0,
  SCHEDULED = 1,
  PENDING_PICKUP = 2,
  READY_FOR_REPORT = 3,
  DONE = 4,
  ARCHIVE = 5,
}
